import { Typography } from 'antd';
import React, { memo } from 'react';
import { useTranslation } from 'react-i18next';

const { Title } = Typography;

interface ReportHeaderProps {
  title: string;
  diagnostic?: string;
  orderDoctorName?: string;
}

const ReportHeader: React.FC<ReportHeaderProps> = ({ title, diagnostic, orderDoctorName }) => {
  const { t } = useTranslation('Vindoc');

  return (
    <div>
      <Title level={5}>{title}</Title>
      <div>
        {t('Admitting Diagnoses')}: {diagnostic}
      </div>
      <div>
        {t('Order Doctor')}: {orderDoctorName}
      </div>
    </div>
  );
};

export default memo(ReportHeader);
